import { render, staticRenderFns } from "./CustomerInsuranceExtend.vue?vue&type=template&id=032e7344&scoped=true&"
import script from "./CustomerInsuranceExtend.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e7344",
  null
  
)

export default component.exports